import React from 'react';

import {
  Checkbox,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import { useDispatch } from 'react-redux';
import { trialStatusOptions } from '../../../../../constants';
import { ITrialClass, TTrialStatus } from '../../../../../store/V2/TrialsSlice';
import {
  TAdminUpdateTrial,
  updateTrialAsAdmin,
} from '../../../../../store/V2/TrialsSlice/adminApi';

interface StatusChangeModalProps {
  open: boolean;
  trialData: ITrialClass;
  onClose: () => void;
  refreshList: () => void;
}

const StatusChangeModal: React.FC<StatusChangeModalProps> = ({
  open,
  trialData,
  onClose,
  refreshList,
}) => {
  const dispatch = useDispatch();

  const handleStatusChange = (value: TTrialStatus) => {
    if (trialData && trialData._id) {
      const apiData: TAdminUpdateTrial = {
        _id: trialData._id,
        status: value,
      };
      dispatch(updateTrialAsAdmin(apiData));
      onClose();
      refreshList();
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { padding: '30px', borderRadius: '20px' } }}
    >
      <DialogTitle sx={{ paddingTop: '0px' }}>
        Change Trial Class Status
      </DialogTitle>
      <List>
        {trialStatusOptions
          .filter((status) => status.value !== 'CANCELED')
          .map((status, index) => {
            const isSelected = trialData.status === status.value;
            return (
              <ListItem disableGutters disablePadding key={index}>
                <ListItemButton
                  onClick={() =>
                    handleStatusChange(status.value as TTrialStatus)
                  }
                  selected={isSelected}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={isSelected}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText primary={status.value} />
                </ListItemButton>
              </ListItem>
            );
          })}
      </List>
    </Dialog>
  );
};

export default StatusChangeModal;
